import { useState } from "react";
import { PhotoIcon } from "@heroicons/react/24/outline";
//import { useRecipeWithImage } from "../hooks/useRecipeWithImage";
import RecipeSlidePanel from "./RecipeSlidePanel";

export default function RecipeCompactCard({ recipe }) {
  const [showPanel, setShowPanel] = useState(false);
  //const { recipe: liveRecipe } = useRecipeWithImage(recipe._id, recipe);

  const liveRecipe = recipe;
  
  if (!liveRecipe) {
    return (
      <div className="border rounded shadow bg-white p-4 flex items-center justify-center text-gray-400">
        Loading recipe...
      </div>
    );
  }

  return (
    <>
      <div
        className="border rounded shadow bg-white flex flex-col gap-2 cursor-pointer hover:scale-[1.02] transition-transform duration-200 shadow" 
        onClick={() => setShowPanel(true)}
      >
        {/* IMAGE + CONTENT */}
        <div className="flex gap-2 lg:gap-4 place-items-start md:p-2">
          {/* Left: Image */}
          <div className="w-32 h-32 flex-shrink-0 rounded overflow-hidden bg-gray-100">
            {liveRecipe.image ? (
              <img
                src={liveRecipe.image}
                alt={liveRecipe.name}
                className="w-full h-full object-cover opacity-0 transition-opacity duration-700"
                onLoad={(e) => (e.currentTarget.style.opacity = 1)}
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center animate-pulse">
                <PhotoIcon className="h-8 w-8 text-gray-400" />
              </div>
            )}
          </div>

          {/* Right: Title + Stats */}
          <div className="flex-1 min-w-0 p-2 md:p-0">
            <h3 className="text-base font-semibold text-gray-800 mb-1">
                {liveRecipe.name}
            </h3>

            <div className="text-xs text-gray-600 mt-1">
                Prep: {liveRecipe.prepTime}
                <span className="mx-2 text-gray-400">|</span>
                Cook: {liveRecipe.cookTime}
            </div>

            {/* Summary */}
            <p className="text-xs italic text-gray-700 mt-1 truncate md:whitespace-normal md:overflow-visible md:truncate-none">
                {liveRecipe.summary}
            </p>
            </div>
        </div>
      </div>

      <RecipeSlidePanel
        isOpen={showPanel}
        onClose={() => setShowPanel(false)}
        recipe={liveRecipe}
      />
    </>
  );
}
